import React, { ReactElement } from "react"

import styles from "./Section.scss"

interface Props {
  title: string
  children: ReactElement
}

const Section = ({ children, title }: Props) => (
  <div className={styles.section}>
    <h2>{title}</h2>
    <hr />
    <div>{children}</div>
  </div>
)

export default Section
